import { Utils } from "arv-reactcomponents";

const movePreview = (
  pageY,
  pageX,
  targetElem,
  previewContainer,
  previewImg,
) => {
  const elem = targetElem;
  const zoomElem = previewContainer;
  const zoomElemImg = previewImg;

  const elemVals = Utils.getBoundClientRect(elem);
  const zoomElemVals = Utils.getBoundClientRect(zoomElem);
  const imgVals = Utils.getBoundClientRect(zoomElemImg);

  const wDiff = (imgVals.width - zoomElemVals.width) / elemVals.width;
  const hDiff = (imgVals.height - zoomElemVals.height) / elemVals.height;

  const zoomPageX = (pageX - elemVals.left) * wDiff;
  const zoomPageY = (pageY - elemVals.top) * hDiff;

  Utils.scrollTo(zoomElem, zoomPageX, zoomPageY);
};

const imageAlt = () => {
  const path = window.location.pathname;
  return path
    .replace(/-\w+$/, "")
    .replace(/[^\w]/g, " ")
    .trim();
};

export default {
  movePreview,
  imageAlt,
};



// WEBPACK FOOTER //
// ./src/component/PdpComponents/MainCarousel/methods.js